import axios from 'axios';
import Auth from '../services/auth';
import moment from 'moment';
import { API_ROOT } from './apiConfig';

export default class UserDataAccess {

    getAccounts() {

        const auth = new Auth();

        return auth.getUserAccounts();
    }

    getAll() {

        const auth = new Auth();

        return new Promise((resolve, reject) => {


            axios.get(`${API_ROOT}/api/v1/users/foraccount?account=${auth.getActiveAccount()}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    const users = response.data.map((user, i) => {
                        const result = Object.assign({}, user,
                            {
                                id: user.Id,
                                RolesDisplay: user.Roles.join(', '),
                                //DateOfService: moment(report.DateOfService).format('MM/DD/YYYY'),
                                //Confirmed: (user.EmpId.indexOf('yahoo') > 0 || user.EmpId.indexOf('gmail') > 0) ? 'No' : 'Yes',
                                Email: user.EMail || user.EmpId,
                                UserName: user.IdentityMode === 1 ? user.EMail : user.UserId ,
                                LastWebAccess: moment(user.LastWebAccess).isValid() ? moment(user.LastWebAccess).format("MM/DD/YYYY") : 'NA',
                                SSOIdentity: user.SSOIdentity,
                                Active: user.Active
                            });

                        return result;
                    });

                    resolve(users);


                })
                .catch(error => {
                });
        });
    }

    writeAudit(auditEvent) {
        const auth = new Auth();

        return new Promise((resolve, reject) => {


            axios.post(`${API_ROOT}/api/v1/Users/WriteAudit`,
                auditEvent,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                  
                    resolve(true);


                })
                .catch(error => {
                });
        });
    }

    getAvailableDictators(accounts) {



        const auth = new Auth();

        return new Promise((resolve, reject) => {

            axios.post(`${API_ROOT}/api/v1/Users/AvailableDictators?isFacilityAdmin=${auth.isInRole('FacilityAdmin')}`,
                accounts,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    const dictators = response.data.map((dictator, i) => {
                        const result = Object.assign({}, dictator,
                            {
                                Name: `${dictator.Physician} - ${dictator.Account}-${dictator.DictatorId}`,
                                //DateOfService: moment(report.DateOfService).format('MM/DD/YYYY'),

                            });

                        return result;
                    });

                    resolve(dictators);


                })
                .catch(error => {
                });
        });
    }

    getDictatorsByAccount(account) {



        const auth = new Auth();

        return new Promise((resolve, reject) => {

            axios.get(`${API_ROOT}/api/v1/Dictators?account=${account}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    const dictators = response.data.map((dictator, i) => {
                        const result = Object.assign({}, dictator,
                            {
                                Name: `${dictator.Physician} - ${dictator.Account}-${dictator.DictatorId}`,
                                //DateOfService: moment(report.DateOfService).format('MM/DD/YYYY'),

                            });

                        return result;
                    });

                    resolve(dictators);


                })
                .catch(error => {
                });
        });
    }

    saveUser(user) {
        
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            var serviceUrl = `${API_ROOT}/api/v1/Users/Create`;
            if (user.Id > 0) {
                serviceUrl = `${API_ROOT}/api/v1/Users/Update`;
            }

            axios.post(serviceUrl,
                user,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);

                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    upgradeDictatorUser(user) {

        const auth = new Auth();

        return new Promise((resolve, reject) => {

            var serviceUrl = `${API_ROOT}/api/v1/Users/UpgradeDictatorAccount`;
            axios.post(serviceUrl,
                user,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);

                })
                .catch(error => {
                    reject(error);
                });
        });
    }   

    getUserById(account, userId) {

        const auth = new Auth();

        return new Promise((resolve, reject) => {


            axios.get(`${API_ROOT}/api/v1/users/getuser?account=${account}&id=${userId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    // const users = response.data.map((user, i) => {
                    const result = Object.assign({}, response.data,
                        {
                            id: response.data.Id
                            //DateOfService: moment(report.DateOfService).format('MM/DD/YYYY'),

                        });

                    // return result;
                    // });

                    resolve(result);


                })
                .catch(error => {
                });
        });
    }

    changePassword(changeRequest) {

        const auth = new Auth();

        return new Promise((resolve, reject) => {


            axios.post(`${API_ROOT}/api/v1/Users/ChangePassword`,
                changeRequest,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    if (response) {
                        auth.clearPasswordExpExpiresIn();
                    }

                    resolve(response);
                    
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getRegistration(code) {

        return new Promise((resolve, reject) => {


            axios.get(`${API_ROOT}/api/v1/Users/ValidateResetPasswordRequest?request=${code}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }).then(function (response) {

                    resolve(response.data);


                })
                .catch(error => {
                });
        });
    }

    SendIdentityEmailConfirmation(account, luid) {

        const auth = new Auth();


        return new Promise((resolve, reject) => {


            axios.get(`${API_ROOT}/api/v1/Users/SendIdentityEmailConfirmation?account=${account}&luid=${luid}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    resolve(response.data);

                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    resetConfirmation(account, luid) {

        const auth = new Auth();


        return new Promise((resolve, reject) => {


            axios.get(`${API_ROOT}/api/v1/Users/ResetIdentityMode?account=${account}&luid=${luid}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {

                    resolve(response.data);

                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    resetPassword(request) {

        return new Promise((resolve, reject) => {


            axios.post(`${API_ROOT}/api/v1/Users/ResetPassword`,
                request,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }).then(function (response) {

                    resolve(response.data);
                    
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    requestPasswordReset(email) {

        return new Promise((resolve, reject) => {

            let request = { Email: email };
            axios.post(`${API_ROOT}/api/v1/Users/RequestPasswordReset`,
                request,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }).then(function (response) {

                    resolve(true);

                })
                .catch(error => {
                    resolve(true);
                });
        });
    }


    confirmIdentity(userRequest) {
        const auth = new Auth();
        return new Promise((resolve, reject) => {

            axios.post(`${API_ROOT}/api/v1/Users/ConfirmIdentity`,
                userRequest,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);

                })
                .catch(error => {

                    reject(error);
                });
        });
    }

    confirmUserName(userRequest) {
        const auth = new Auth();
        return new Promise((resolve, reject) => {

            axios.post(`${API_ROOT}/api/v1/Users/UpdateIdentity`,
                userRequest,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);

                })
                .catch(error => {

                    reject(error);
                });
        });
    }

    SendVerificationCode(userRequest) {
        const auth = new Auth();
        return new Promise((resolve, reject) => {

            axios.post(`${API_ROOT}/api/v1/Users/SendVerificationCode`,
                userRequest,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    confirmEmailCode(userRequest) {
        const auth = new Auth();
        return new Promise((resolve, reject) => {

            axios.post(`${API_ROOT}/api/v1/Users/ConfirmEmailCode`,
                userRequest,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);

                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    confirmEmail(email, code) {

        return new Promise((resolve, reject) => {

            resolve(true);
        });
    }

    getDictatorInfo(userId, account) {

        const auth = new Auth();
        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "sql", command: "GetDictatorInfo", parameters: { userId: userId, account: account }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getIsCodingUser(account) {

        const auth = new Auth();
        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "sql", command: "GetFacilityServices", parameters: { account: account }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    const isCoding = Boolean(response.data[0].IsCoding);
                    resolve(isCoding);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    GetIsUpgradedValue(userId, account) {

        const auth = new Auth();
        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "sql", command: "GetIsUpgradedValue", parameters: { userId: userId, account: account }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    SetUpgradedValue(userId, account) {

        const auth = new Auth();
        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "sql", command: "SetUpgradedValue", parameters: { userId: userId, account: account }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    IsSSOIdentityConfigured(email) {

        const auth = new Auth();
        return new Promise((resolve, reject) => {

            let request = { Email: email, Command: "dbo.SP_IsSSOIdentityConfigured" };
            axios.post(`${API_ROOT}/api/v1/Users/GeneralValidations`,
                request,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function(response) {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    IsActiveUser(email) {

        const auth = new Auth();
        return new Promise((resolve, reject) => {

            let request = { Email: email, Command: "dbo.SP_IsActiveUser" };
            axios.post(`${API_ROOT}/api/v1/Users/GeneralValidations`,
                request,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/userDataAccess.js